import React from 'react';

const ITEMS = [
  {
    label: '事業者名',
    value: '株式会社オーサム・ベース',
  },
  {
    label: '運営責任者',
    value: '※請求により遅滞なく開示します',
  },
  {
    label: '所在地',
    value: '※請求により遅滞なく開示します',
  },
  {
    label: '電話番号',
    value: '※請求により遅滞なく開示します（受付時間：平日10:00〜18:00）',
  },
  {
    label: 'メールアドレス',
    value: 'info@036base.com',
  },
  {
    label: 'サービス名',
    value: 'えがおフォルダ（Smile Folder）',
  },
  {
    label: '販売価格',
    value: (
      <>
        ・フリープラン：無料（累計100枚まで）<br />
        ・スタンダードプラン：月額 3,300円（税込）／毎月1,000枚まで<br />
        ・プレミアムプラン：月額 9,900円（税込）／毎月10,000枚まで
      </>
    ),
  },
  {
    label: '商品代金以外の必要料金',
    value: 'インターネット接続料金、通信料金等はお客様のご負担となります。',
  },
  {
    label: '支払方法',
    value: (
      <>
        クレジットカード決済（Stripe）<br />
        ※カード情報は Stripe（Stripe Payments Japan株式会社 / Stripe, Inc.（米国））のサーバーで処理され、当社サーバーには保存されません。決済処理に必要な範囲で氏名・メールアドレス等が Stripe（米国を含む）に提供されます。詳細はプライバシーポリシー「外国への個人データの移転」をご参照ください。
      </>
    ),
  },
  {
    label: '支払時期',
    value: '初回：プラン契約時に即時決済。以降：毎月の更新日に自動決済。',
  },
  {
    label: '商品の引渡時期',
    value: '決済完了後、即時にサービスの利用が可能となります。',
  },
  {
    label: '無料トライアル',
    value: (
      <>
        新規登録時、有料プランは最大14日間の無料トライアル期間を設けています。<br />
        トライアル期間中はいつでもキャンセル可能で、料金は一切発生しません（開始直後の解約も同様です）。<br />
        トライアル期間満了の時点で解約手続きがされていない場合、自動的に有料プランへ移行し初回課金が発生します。
      </>
    ),
  },
  {
    label: 'プラン解約（サブスクリプションのみ停止）',
    value: (
      <>
        マイページの「料金管理」ページから、Stripe カスタマーポータル経由でいつでも解約手続きが可能です。<br />
        解約手続き後も、現在の課金期間の終了日まではサービスをご利用いただけます（期間末解約）。<br />
        次回更新日以降の課金は発生しません。<strong>期間途中での日割り返金は行いません。</strong>
      </>
    ),
  },
  {
    label: 'アカウント退会（データ削除を伴う）',
    value: (
      <>
        マイページの「プロフィール」ページから退会手続きが可能です。<br />
        退会と同時に、登録された顔データ・サブスクリプションが即時キャンセルされ、ユーザーデータは 30 日後に完全削除されます（即時完全削除のオプションもご利用いただけます）。<br />
        <strong>退会に伴うサブスクリプションの即時キャンセルでは、課金期間途中であっても日割り返金は行いません。</strong>サービスを当月末まで利用したい場合は、退会ではなく「プラン解約」をご選択ください。
      </>
    ),
  },
  {
    label: '返品・返金',
    value: (
      <>
        デジタルサービスの性質上、お支払い済みの料金については、原則として返金いたしません（期間途中の解約・退会を含む）。<br />
        無料トライアル期間中の解約については料金が発生しないため、返金の対象外です。<br />
        当社の責めに帰すべき事由によりサービスが利用できなかった場合は、別途協議の上、対応いたします。
      </>
    ),
  },
  {
    label: '動作環境',
    value: (
      <>
        ・Web版：Google Chrome / Safari / Microsoft Edge の最新版<br />
        ・デスクトップ版：Windows 10 / 11（64bit）
      </>
    ),
  },
];

export default function CommerceLawPage({ onBack }) {
  return (
    <div style={{
      height: '100vh',
      background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
      padding: '40px 16px',
      overflowY: 'auto',
      boxSizing: 'border-box',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 24,
        padding: '40px 36px',
        maxWidth: 720,
        margin: '0 auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>📜</div>
          <h1 style={{
            fontSize: 24, fontWeight: 900, color: '#7048D4', margin: 0,
          }}>
            特定商取引法に基づく表記
          </h1>
          <p style={{ fontSize: 13, color: '#888', marginTop: 8 }}>
            最終更新日：2026年5月17日
          </p>
        </div>

        <table style={{
          width: '100%', borderCollapse: 'collapse', fontSize: 14, lineHeight: 1.7,
        }}>
          <tbody>
            {ITEMS.map((item, i) => (
              <tr key={i} style={{ borderBottom: '1px solid #f0e6f6' }}>
                <th style={{
                  textAlign: 'left', verticalAlign: 'top',
                  width: 180, padding: '14px 12px 14px 0',
                  color: '#7048D4', fontWeight: 700, fontSize: 13,
                }}>
                  {item.label}
                </th>
                <td style={{ padding: '14px 0', color: '#444' }}>
                  {item.value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{
          marginTop: 28, padding: '16px 18px',
          background: '#FAF6FF', borderRadius: 12, fontSize: 12, color: '#666', lineHeight: 1.7,
        }}>
          ※「請求により遅滞なく開示」と記載した項目につきましては、
          <a href="mailto:info@036base.com" style={{ color: '#9B5FE3' }}>info@036base.com</a>
          までお問い合わせください。営業日（平日）3日以内に開示いたします。
        </div>

        {onBack && (
          <div style={{ textAlign: 'center', marginTop: 32 }}>
            <button
              type="button"
              onClick={onBack}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                color: '#9B5FE3', fontSize: 14, textDecoration: 'underline',
              }}
            >
              ← 戻る
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
